import getFieldFactory from "./FieldFactory";
import createPost from "../Action/CreatePosts/CreatePostFactory";

const editPost = [
	{
		defaultFields: [
			{
				name:   'ID',
				label:  'The ID of the post you want to edit:',
				renderRemoveField: false,
        isCollapsed: false,
				fields: [
					getFieldFactory().getSourceField(), getFieldFactory().getValueInputType( 'input', 'Post ID' ), getFieldFactory().getParametersField(),
				],
			}
		],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		taxonomyRelationType: 'AND',
		taxonomies: [],
		shouldAppendTerms: true
	}
];

const editUsers = [
	{
		defaultFields: [
			{
				name:   'ID',
				label:  'The ID of the user you want to edit:',
				renderRemoveField: false,
				fields: [
					getFieldFactory().getSourceField(), getFieldFactory().getValueInputType( 'input', 'User ID' ), getFieldFactory().getParametersField(),
				],
			}
		],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
	}
];
const restApiCall = [
	{
		headers: [],
		output: [],
		basic: [
			{
				name: 'method',
				label: 'Method',
				fields: [
					{
						id:           'value',
						inputType:    'select',
						source:       'methods',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Value',
						dynamic:      false,
						defaultValue: 'Select a method',
					},
				],
			},
			{
				name: 'url',
				label: 'URL',
				fields: [
					{
						id:           'value',
						inputType:    'input',
						value:        '',
						label:        'Value',
						dynamic:      false,
						defaultValue: '',
					},
				],
			},
			{
				name: 'basic_auth',
				label: 'Basic authentication',
				fields: [
					{
						id:           'user',
						inputType:    'input',
						value:        '',
						label:        'User',
						dynamic:      false,
						defaultValue: '',
					},
					{
						id:           'password',
						inputType:    'input-password',
						value:        '',
						label:        'Password',
						dynamic:      false,
						defaultValue: '',
					},
				],
			},
		],
		requestBody: [],
    requestParameters: []
	},
];

const customSQLQuery = [
  {
    headers: [],
    output: [],
    basic: [
      {
        name: 'query',
        label: 'Type the desired SQL query below',
        fields: [
          {
            id:           'restRoutesQueryEditor',
            inputType:    'textarea',
            sourceName:   'name',
            sourceValue:  'value',
            value:        '',
            label:        '',
            dynamic:      false,
          },
        ],
      },
    ]
  },
];

const createPosts = [
	{
		defaultFields: [],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		taxonomyRelationType: 'AND',
		taxonomies: [],
    taxonomiesFields: [],
	}
];

const createTaxonomies = [
	{
		defaultFields: [],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		taxonomyRelationType: 'AND',
	}
];

const createUsers = [
	{
		defaultFields: [],
		customFields: [],
		mainRelationType: 'AND',
		taxonomyRelationType: 'AND',
	}
];

const displayTaxonomies = [
	{
		defaultFields: [],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		output: [],
		limit: [
			{
				name: 'limit',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
		offset: [
			{
				name:   'offset',
				label:  '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
    pagination: [
      {
        name:   'pagination',
        label:  'Pagination',
        fields: [
          getFieldFactory().getSourceSimpleField(),
          getFieldFactory().getValueInputType(),
          getFieldFactory().getParametersField(),
        ],
      }
    ],
		order: [
			{
				name: 'order',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'order',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order',
						defaultValue: 'Select an order',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
		orderby: [
			{
				name: 'orderby',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'orderByTaxonomy',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order by',
						defaultValue: 'Select a value',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
	}
];

const displayUsers = [
	{
		defaultFields: [],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		output: [],
		limit: [
			{
				name: 'limit',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
		offset: [
			{
				name:   'offset',
				label:  '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
    pagination: [
      {
        name:   'pagination',
        label:  'Pagination',
        fields: [
          getFieldFactory().getSourceSimpleField(),
          getFieldFactory().getValueInputType(),
          getFieldFactory().getParametersField(),
        ],
      }
    ],
		order: [
			{
				name: 'order',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'order',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order',
						defaultValue: 'Select an order',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
		orderby: [
			{
				name: 'orderby',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'orderByUsers',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order by',
						defaultValue: 'Select a value',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
					{
						id:           'customFieldOrderBy',
						inputType:    'input',
						label:        'Custom field name',
						value:        '',
					}
				],
			}
		],
	}
];

const displayData = [
	{
		defaultFields: [],
		queryGroups: [],
		customFields: [],
		mainRelationType: 'AND',
		taxonomyRelationType: 'AND',
		taxonomies: [],
		output: [],
		limit: [
			{
				name: 'limit',
				label: '',
				fields: [
					getFieldFactory().getSourceSimpleField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
		offset: [
			{
				name:   'offset',
				label:  '',
				fields: [
					getFieldFactory().getSourceSimpleField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
    pagination: [
      {
        name:   'pagination',
        label:  'Pagination',
        fields: [
          getFieldFactory().getSourceSimpleField(),
          getFieldFactory().getValueInputType(),
          getFieldFactory().getParametersField(),
        ],
      }
    ],
		order: [
			{
				name: 'order',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'order',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order',
						defaultValue: 'Select an order',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
		orderby: [
			{
				name: 'orderby',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'orderby',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order by',
						defaultValue: 'Select a value',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
					{
						id:           'customFieldOrderBy',
						inputType:    'input',
						label:        'Custom field name',
						value:        '',
					}
				],
			}
		],
	}
];

const displayCustomTable = [
	{
		tableSelection: [
			{
				name: 'table',
				label: '',
				fields: [
					{
						id: 'value',
						inputType: 'select',
						source: 'dynamicFetch',
						fetchType: 'tables',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Table',
						defaultValue: 'Select a table',
						dynamic: false
					},
				],
			}
		],
		defaultFields: [],
		mainRelationType: 'AND',
		output: [],
		limit: [
			{
				name: 'limit',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
		offset: [
			{
				name:   'offset',
				label:  '',
				fields: [
					getFieldFactory().getSourceField(),
					getFieldFactory().getValueInputType(),
					getFieldFactory().getParametersField(),
				],
			}
		],
    pagination: [
      {
        name:   'pagination',
        label:  'Pagination',
        fields: [
          getFieldFactory().getSourceSimpleField(),
          getFieldFactory().getValueInputType(),
          getFieldFactory().getParametersField(),
        ],
      }
    ],
		order: [
			{
				name: 'order',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'order',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Order',
						defaultValue: 'Select an order',
						dynamic: true
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
		orderby: [
			{
				name: 'orderby',
				label: '',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						sourceName: 'name',
						sourceValue: 'value',
						source: 'dynamicFetch',
						value: '',
						label: 'Order by',
						defaultValue: 'Select an order',
						dynamic: true,
						dynamicFetch: true,
						fetchType: 'columns'
					},
					getFieldFactory().getParametersField(),
				],
			}
		],
	}
];

const createCustomTable = [
	{
		tableSelection: [
			{
				name: 'table',
				label: '',
				fields: [
					{
						id: 'value',
						inputType: 'select',
						source: 'dynamicFetch',
						fetchType: 'tables',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Table',
						defaultValue: 'Select a table',
						dynamic: false
					},
				],
			}
		],
		defaultFields: [],
	}
];

const editCustomTable = [
	{
		tableSelection: [
			{
				name: 'table',
				label: '',
				fields: [
					{
						id: 'value',
						inputType: 'select',
						source: 'dynamicFetch',
						fetchType: 'tables',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Table',
						defaultValue: 'Select a table',
						dynamic: false
					},
				],
			}
		],
		defaultFields: [],
		filters: [],
		mainRelationType: 'AND',
	}
];

const deleteCustomTable = [
	{
		tableSelection: [
			{
				name: 'table',
				label: '',
				fields: [
					{
						id: 'value',
						inputType: 'select',
						source: 'dynamicFetch',
						fetchType: 'tables',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Table',
						defaultValue: 'Select a table',
						dynamic: false
					},
				],
			}
		],
		defaultFields: [],
		filters: [],
		mainRelationType: 'AND',
	}
];

function createEndpoint() {
	return {
		method: '',
		action: 'display_data',
		opacity: 1,
		capability: 'all',
		enabled: true,
		parameters: [],
		createPost: [
			createPost()
		],
		displayData: displayData,
		createPosts: createPosts,
		editPost: editPost,
		displayTaxonomies: displayTaxonomies,
		createTaxonomies: createTaxonomies,
		displayUsers: displayUsers,
		editUsers: editUsers,
		createUsers: createUsers,
		displayCustomTable: displayCustomTable,
		createCustomTable: createCustomTable,
		editCustomTable: editCustomTable,
		deleteCustomTable: deleteCustomTable,
		restApiCall: restApiCall,
    customSQLQuery: customSQLQuery,
		actionSection: false,
		parametersSection: false,
		methodSection: true,
		privacySection: false,
		actionBodySection: false
	}
}

export {createEndpoint, displayCustomTable, displayTaxonomies, createPosts, displayData, restApiCall}
